import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../../constants/ActionTypes";
import CheckoutSteps from "../../../../constants/CheckoutSteps";
import { prepareUrlForRedirectToCheckout } from "../../../../utilites/util";
import { apiRequest } from "../../api/actions";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { createErrorNotification } from "../../notification/actions";
import { redirectToAction } from "../../redirection/actions";
import { setLoader } from "../../ui/actions";
import { setDefaultCheckoutData } from "./actions";
import Config from "../../../../config/config";
import Segments from "../../../../constants/Segments";
import ProductTypesUrl from "../../../../constants/ProductTypesUrl";
import ChangeOrderDeviceColorMiddlewareProxy from "./ChangeOrderDeviceColorMiddlewareProxy";
import RemoveOrderItemFromBasketMiddlewareProxy from "./RemoveOrderItemFromBasketMiddlewareProxy";
import ChooseDifferentAccessoryMiddleware from "./ChooseDifferentAccessoryMiddlewareProxy";
import { OrderTypes } from "../../../../constants/OrderTypes";

export const submitManhattanOrderMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.SUBMIT:
    next(apiRequest(
      null,
      'POST', ApiUrls.ORDER_SUBMIT,
      null,
      store.getState().manhattan.bundleData,
      MiddlewareEntities.ORDER.MANHATTAN_SUBMIT,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.ORDER.MANHATTAN_SUBMIT));
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN_SUBMIT} ${ActionTypes.API_SUCCESS}` :
    const language = store.getState().language.language as "sr" | "en";
    const section = store.getState().section.section;
    next(setDefaultCheckoutData());
    next(redirectToAction(prepareUrlForRedirectToCheckout(language, section, CheckoutSteps[language].checkout)));
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN_SUBMIT} ${ActionTypes.API_ERROR}` :
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.ORDER.MANHATTAN_SUBMIT));
    next(setLoader(false, MiddlewareEntities.ORDER.MANHATTAN_SUBMIT));
    break;
  }
};

export const cancelOrderMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case `${ActionTypes.ORDER.MANHATTAN.CANCEL_ORDER}` :
    next(apiRequest(
      null,
      'DELETE',
      `${ApiUrls.ORDER_SUBMIT}`,
      null,
      null,
      MiddlewareEntities.ORDER.MANHATTAN_CANCEL,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.ORDER.MANHATTAN_CANCEL));
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN_CANCEL} ${ActionTypes.API_SUCCESS}`:
    const { ore } = store.getState().manhattanOrder.order.basket;
    const language = store.getState().language.language;
    const { purchase } = store.getState().productData.productData;
    const type = store.getState().manhattanOrder.order.type;
    const productTypeUrl = type === OrderTypes.ACCESSORY ? ProductTypesUrl[language].accessory : ProductTypesUrl[language].phone;

    if (ore) {
      const { offerId } = ore;
      const offerUrl = offerId ? `?offerId=${offerId}` : '';
      store.dispatch(redirectToAction(`${Config.prefixUrl}/${language}/campaigns/list${offerUrl}`));
    } else {
      store.dispatch(redirectToAction(`${Config.prefixUrl}/${language}/${Segments[language].PRIVATE_SEGMENT}/${productTypeUrl}?purchase=${purchase}`));
    }
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN_CANCEL} ${ActionTypes.API_ERROR}` :
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.ORDER.MANHATTAN_CANCEL));
    break;
  }
};

export const changeOrderDeviceColorMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.CHANGE_DEVICE_COLOR:
    ChangeOrderDeviceColorMiddlewareProxy.callAPI(store, next, action.payload);
    break;
  case `${MiddlewareEntities.ORDER.CHANGE_DEVICE_COLOR} ${ActionTypes.API_SUCCESS}` :
    ChangeOrderDeviceColorMiddlewareProxy.handleAPISuccess(next, action.payload.data);
    break;
  case `${MiddlewareEntities.ORDER.CHANGE_DEVICE_COLOR} ${ActionTypes.API_ERROR}` :
    ChangeOrderDeviceColorMiddlewareProxy.handleAPIError(store.getState(), next, action.payload);
    break;
  default:
    break;
  }
};

export const removeOrderItemFromBasketMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.REMOVE_ITEM_FROM_BASKET:
    RemoveOrderItemFromBasketMiddlewareProxy.callAPI(next, action.payload);
    break;
  case `${MiddlewareEntities.ORDER.REMOVE_ITEM_FROM_BASKET} ${ActionTypes.API_SUCCESS}` :
    RemoveOrderItemFromBasketMiddlewareProxy.handleAPISuccess(next);
    break;
  case `${MiddlewareEntities.ORDER.REMOVE_ITEM_FROM_BASKET} ${ActionTypes.API_ERROR}` :
    RemoveOrderItemFromBasketMiddlewareProxy.handleAPIError(store.getState(), next, action.payload);
    break;
  default:
    break;
  }
};

export const chooseDifferentAccessoryMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.PREPARE_BASKET_ITEM_FOR_REPLACEMENT:
    ChooseDifferentAccessoryMiddleware.callAPI(next, action.payload);
    break;
  case `${MiddlewareEntities.ORDER.PREPARE_BASKET_ITEM_FOR_REPLACEMENT} ${ActionTypes.API_SUCCESS}` :
    ChooseDifferentAccessoryMiddleware.handleAPISuccess(store.getState(), next);
    break;
  case `${MiddlewareEntities.ORDER.PREPARE_BASKET_ITEM_FOR_REPLACEMENT} ${ActionTypes.API_ERROR}` :
    ChooseDifferentAccessoryMiddleware.handleAPIError(store.getState(), next, action.payload);
    break;
  default:
    break;
  }
};


export const orderManhattanMiddleware = [
  submitManhattanOrderMiddleware,
  cancelOrderMiddleware,
  changeOrderDeviceColorMiddleware,
  removeOrderItemFromBasketMiddleware,
  chooseDifferentAccessoryMiddleware
];

